import {
  SET_IA_AGENT_UI_FLAG,
  CLEAR_IA_AGENTS,
  SET_IA_AGENTS,
  SET_IA_AGENT_ITEM,
  SET_IA_AGENT_ASSISTANTS,
  SET_IA_AGENT_KNOWLEDGE_SOURCES,
  ADD_IA_AGENT_KNOWLEDGE_SOURCE,
  REMOVE_IA_AGENT_KNOWLEDGE_SOURCE,
} from './types';

export const mutations = {
  [SET_IA_AGENT_UI_FLAG]($state, uiFlags) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...uiFlags,
    };
  },

  [CLEAR_IA_AGENTS]($state) {
    $state.records = {};
  },

  [SET_IA_AGENTS]($state, data) {
    $state.records = data;
  },

  [SET_IA_AGENT_ITEM]($state, data) {
    $state.records[data.id] = {
      ...($state.records[data.id] || {}),
      ...data,
    };
  },

  [SET_IA_AGENT_ASSISTANTS]($state, { iaAgentId, assistants }) {
    if ($state.records[iaAgentId]) {
      $state.records[iaAgentId].assistants = assistants;
    }
  },

  [SET_IA_AGENT_KNOWLEDGE_SOURCES]($state, { iaAgentId, knowledgeSources }) {
    if ($state.records[iaAgentId]) {
      $state.records[iaAgentId].knowledge_sources = knowledgeSources;
    }
  },

  [ADD_IA_AGENT_KNOWLEDGE_SOURCE]($state, { iaAgentId, knowledgeSource }) {
    if ($state.records[iaAgentId]) {
      const knowledgeSources = $state.records[iaAgentId].knowledge_sources || [];
      $state.records[iaAgentId].knowledge_sources = [...knowledgeSources, knowledgeSource];
    }
  },

  [REMOVE_IA_AGENT_KNOWLEDGE_SOURCE]($state, { iaAgentId, knowledgeSourceId }) {
    if ($state.records[iaAgentId] && $state.records[iaAgentId].knowledge_sources) {
      $state.records[iaAgentId].knowledge_sources = $state.records[iaAgentId].knowledge_sources.filter(
        source => source.id !== knowledgeSourceId
      );
    }
  },
}; 